module.exports = __webpack_public_path__ + "static/pic03-4e99789edbcae669e76819b60b7a3e23.jpg";